module.exports = __webpack_public_path__ + "static/media/REDCap_API_Demo.9b716d20.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/informatics/REDCap_API_Demo.pdf
// module id = 410
// module chunks = 0